import { render, staticRenderFns } from "./MinksPay.vue?vue&type=template&id=0d71871a&"
import script from "./MinksPay.vue?vue&type=script&lang=js&"
export * from "./MinksPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports